import type { Step } from "react-joyride";

export const qcResultTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າສະຫຼຸບຜົນ QC! ຫນ້ານີ້ຈະສະແດງສະຖິຕິແລະການວິເຄາະຜົນກວດ QC ທັງໝົດ. ທ່ານສາມາດເບິ່ງສະຖິຕິລວມ, ອັດຕາຜ່ານ/ບໍ່ຜ່ານ, ສະຖິຕິຕາມພະແນກ, ບັນຫາທີ່ພົບເລື້ອຍ, ລາຍການທີ່ບໍ່ຜ່ານ, ແລະແນວໂນ້ມຜົນກວດ QC. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="result-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດເລືອກພະແນກທີ່ຕ້ອງການເບິ່ງສະຖິຕິ, ເລືອກຊ່ວງວັນທີ (ວັນທີເລີ່ມຕົ້ນ - ວັນທີສິ້ນສຸດ), ແລະກົດປຸ່ມ 'ກວດສອບ' ເພື່ອດຶງຂໍ້ມູນຕາມການກອງທີ່ເລືອກ. ຖ້າບໍ່ເລືອກພະແນກ, ຈະສະແດງສະຖິຕິທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="result-stats-cards"]',
    content:
      "ນີ້ແມ່ນບັດສະຖິຕິລວມ. ທ່ານຈະເຫັນຈຳນວນການກວດ QC ທັງໝົດ, ຈຳນວນທີ່ຜ່ານ, ຈຳນວນທີ່ບໍ່ຜ່ານ, ແລະຈຳນວນທີ່ກຳລັງກວດສອບ. ບັດເຫຼົ່ານີ້ຈະຊ່ວຍໃຫ້ທ່ານເຂົ້າໃຈພາບລວມຂອງຜົນກວດ QC ໄດ້ຢ່າງໄວ.",
    placement: "top",
  },
  {
    target: '[data-tourid="result-charts"]',
    content:
      "ນີ້ແມ່ນພາກອັດຕາຜ່ານ/ບໍ່ຜ່ານ. ທ່ານຈະເຫັນກາຟສະແດງອັດຕາສ່ວນຂອງການກວດ QC ທີ່ຜ່ານແລະບໍ່ຜ່ານ. ກາຟນີ້ຈະຊ່ວຍໃຫ້ທ່ານເຫັນພາບລວມຂອງຄຸນນະພາບການກວດ QC ໄດ້ຢ່າງຊັດເຈນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="result-by-department"]',
    content:
      "ນີ້ແມ່ນພາກສະຖິຕິຕາມພະແນກ. ທ່ານຈະເຫັນສະຖິຕິລວມຂອງຜົນກວດ QC ຂອງແຕ່ລະພະແນກ. ສຳລັບແຕ່ລະພະແນກ, ທ່ານຈະເຫັນຈຳນວນການກວດທັງໝົດ, ຈຳນວນທີ່ຜ່ານ, ຈຳນວນທີ່ບໍ່ຜ່ານ, ແລະອັດຕາຜ່ານ. ຂໍ້ມູນນີ້ຈະຊ່ວຍໃຫ້ທ່ານເຫັນວ່າພະແນກໃດມີຄຸນນະພາບການກວດ QC ດີຫຼືບໍ່.",
    placement: "top",
  },
  {
    target: '[data-tourid="result-problems"]',
    content:
      "ນີ້ແມ່ນພາກບັນຫາທີ່ພົບເລື້ອຍ. ທ່ານຈະເຫັນລາຍການບັນຫາທີ່ພົບເລື້ອຍໃນການກວດ QC ທີ່ບໍ່ຜ່ານ. ສຳລັບແຕ່ລະບັນຫາ, ທ່ານຈະເຫັນຊື່ບັນຫາ, ຈຳນວນຄັ້ງທີ່ພົບ, ແລະອັດຕາສ່ວນ. ຂໍ້ມູນນີ້ຈະຊ່ວຍໃຫ້ທ່ານຮູ້ວ່າຄວນແກ້ໄຂບັນຫາໃດກ່ອນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="result-failed-records"]',
    content:
      "ນີ້ແມ່ນພາກລາຍການທີ່ບໍ່ຜ່ານ. ທ່ານຈະເຫັນລາຍການການກວດ QC ທີ່ບໍ່ຜ່ານລ່າສຸດ. ສຳລັບແຕ່ລະລາຍການ, ທ່ານຈະເຫັນຊື່ມາດຕະຖານ QC, ວັນທີກວດ, ຜູ້ກວດ, ແລະສາເຫດທີ່ບໍ່ຜ່ານ. ທ່ານສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງການກວດ QC ນັ້ນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="result-trend"]',
    content:
      "ນີ້ແມ່ນພາກແນວໂນ້ມຜົນກວດ QC. ທ່ານຈະເຫັນກາຟສະແດງແນວໂນ້ມຜົນກວດ QC ຕາມວັນທີ. ກາຟນີ້ຈະຊ່ວຍໃຫ້ທ່ານເຫັນວ່າຄຸນນະພາບການກວດ QC ປັບປຸງຂຶ້ນຫຼືບໍ່ໃນໄລຍະເວລາທີ່ເລືອກ.",
    placement: "top",
  },
];
